import type { AppProps } from 'next/app';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { sendUserIdToGA } from '@platzi/commons';
import { configureStore } from '../redux/store';
import { createI18n } from '../config/translations/i18n';
import { StructuredData, MetaTags } from '../components/shared/scripts';
import '../utils/styles/normalize.css';
import '../utils/styles/global.css';
import '@fortawesome/fontawesome-svg-core/styles.css';
import '@platzi/ui/dist/css/components.min.css';
import "@platzi/micro-ui.plans/dist/es/all.min.css";
import "@platzi/micro-ui.signup/dist/es/all.min.css";

function MyApp({ Component, pageProps }: AppProps) {
  const store = configureStore(pageProps?.preloadedState?.initialState);
  const i18nInstance = createI18n(pageProps?.preloadedState?.i18n);
  const userId = pageProps?.preloadedState?.initialState?.identity?.user_id;

  const schoolData = pageProps?.preloadedState?.initialState?.school || {};
  const lpData = pageProps?.preloadedState?.initialState?.route || {};
  const plans = pageProps?.preloadedState?.initialState?.plans || {};

  return (
    <>
      <MetaTags meta={pageProps?.preloadedState?.metatags} />
      <Provider store={store}>
        <StructuredData
          schoolData={schoolData}
          lpData={lpData}
          plans={plans}
        />
        <I18nextProvider i18n={i18nInstance}>
          <Component {...pageProps} />
        </I18nextProvider>
        <div
          dangerouslySetInnerHTML={{
            __html: sendUserIdToGA(userId),
          }}
        />
      </Provider>
    </>
  );
}

export default MyApp;
